import { useOutOfStockLang } from './useOutOfStockLang';

export function useOutOfStock() {
  const lang = useOutOfStockLang();
  return {
    lang,
  };
}
